import { render, staticRenderFns } from "./create-team-form.vue?vue&type=template&id=b83f1c42&scoped=true&"
import script from "./create-team-form.vue?vue&type=script&lang=ts&"
export * from "./create-team-form.vue?vue&type=script&lang=ts&"
import style0 from "./create-team-form.vue?vue&type=style&index=0&id=b83f1c42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b83f1c42",
  null
  
)

export default component.exports